export const tvShows = [
  {
    id: 'tv-01',
    title: '重启人生',
    originalTitle: 'ブラッシュアップライフ',
    type: 'tv',
    region: 'jp',
    year: 2023,
    genre: '剧情 / 喜剧 / 奇幻',
    subtitleStatus: 'completed',
    tags: ['穿越', '日常', '治愈', '口碑剧'],
    updatedAt: '2026-09-25',
    popularity: 9640,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20quirky%20Japanese%20slice%20of%20life%20fantasy%20drama%20series%2C%20a%20young%20woman%20walking%20through%20a%20sunlit%20suburban%20street%20with%20floating%20clock%20motifs%2C%20soft%20mint%20and%20warm%20amber%20tones%2C%20cheerful%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-01&orientation=portrait',
    description: '普通女子意外获得重启人生的机会，为了下辈子投个好胎而不断“刷分”。',
    synopsis: '近藤麻美过着平凡的市井生活，却因意外离世而被告知需要积累功德才能转世为人。她一次次重启人生，重读同一段青春，渐渐发现真正重要的并不是分数，而是身边的人。',
    subtitleNote: '字幕组完整还原了关西方言与时代流行语，并为每一轮人生循环标注了时间线索引。',
    subtitleVersions: [
      { id: 'tv-01-v1', language: '简体中文', team: '日常字幕组', format: 'ASS', publishedAt: '2026-09-25', note: '含循环索引' },
      { id: 'tv-01-v2', language: '繁体中文', team: '日常字幕组', format: 'SRT', publishedAt: '2026-08-14' },
      { id: 'tv-01-v3', language: '中日双语', team: '晨光字幕', format: 'ASS', publishedAt: '2026-07-02' },
    ],
  },
  {
    id: 'tv-02',
    title: '静雪',
    originalTitle: 'silent',
    type: 'tv',
    region: 'jp',
    year: 2022,
    genre: '爱情 / 剧情',
    subtitleStatus: 'completed',
    tags: ['纯爱', '听障', '青春', '催泪'],
    updatedAt: '2026-09-20',
    popularity: 9120,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20tender%20Japanese%20youth%20romance%20drama%20series%2C%20two%20figures%20standing%20apart%20in%20falling%20snow%20under%20a%20warm%20street%20lamp%2C%20soft%20slate%20blue%20and%20gentle%20amber%20tones%2C%20quiet%20melancholic%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-02&orientation=portrait',
    description: '曾经的恋人重逢，却因听力逐渐消失而难以传达心意，一段安静而汹涌的爱情。',
    synopsis: '青羽紬在车站偶遇高中时代的恋人佐仓想，却发现对方已因疾病失去大部分听力。两人在沉默与手语之间重新靠近，用文字、眼神与音乐记忆拼凑回那段被时间冲淡的感情。',
    subtitleNote: '字幕组针对手语与书面交流的场景做了画面描述补充，并标注了背景音乐曲目信息。',
    subtitleVersions: [
      { id: 'tv-02-v1', language: '简体中文', team: '澄海字幕组', format: 'ASS', publishedAt: '2026-09-20' },
      { id: 'tv-02-v2', language: '繁体中文', team: '澄海字幕组', format: 'ASS', publishedAt: '2026-08-08' },
    ],
  },
  {
    id: 'tv-03',
    title: '孤独的美食家 第10季',
    originalTitle: '孤独のグルメ Season10',
    type: 'tv',
    region: 'jp',
    year: 2022,
    genre: '美食 / 日常',
    subtitleStatus: 'completed',
    tags: ['美食', '治愈', '下饭', '日常'],
    updatedAt: '2026-09-16',
    popularity: 8260,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20cozy%20Japanese%20food%20travel%20drama%20series%2C%20a%20warm%20bowl%20of%20noodles%20on%20a%20rustic%20table%20with%20soft%20lantern%20light%2C%20rich%20crimson%20and%20golden%20amber%20tones%2C%20appetizing%20intimate%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-03&orientation=portrait',
    description: '井之头五郎继续走街串巷，在不起眼的小店里独自享受一顿顿治愈的美食。',
    synopsis: '经营进口杂货的井之头五郎在跑业务的间隙，总会被街头巷尾的香气吸引。他走进一家家小店，点上一桌看似随意的料理，在专注的进食中享受属于自己的孤独时光。',
    subtitleNote: '字幕组为每集出现的料理与店铺补充了简要说明与菜单译名，方便边看边学边吃。',
    subtitleVersions: [
      { id: 'tv-03-v1', language: '简体中文', team: '下饭字幕组', format: 'SRT', publishedAt: '2026-09-16', note: '含菜单译名' },
      { id: 'tv-03-v2', language: '中日双语', team: '下饭字幕组', format: 'ASS', publishedAt: '2026-07-25' },
    ],
  },
  {
    id: 'tv-04',
    title: '圣域 相扑避难所',
    originalTitle: 'サンクチュアリ -聖域-',
    type: 'tv',
    region: 'jp',
    year: 2023,
    genre: '剧情 / 运动',
    subtitleStatus: 'completed',
    tags: ['相扑', '竞技', '成长', '励志'],
    updatedAt: '2026-09-10',
    popularity: 7840,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Japanese%20sumo%20sports%20drama%20series%2C%20two%20wrestlers%20locked%20in%20a%20clash%20inside%20a%20dramatic%20ring%20of%20light%2C%20deep%20umber%20and%20warm%20amber%20tones%20with%20crimson%20accents%2C%20powerful%20intense%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-04&orientation=portrait',
    description: '一个为钱所困的年轻人闯入相扑的世界，在传统与欲望之间挣扎求生。',
    synopsis: '性格莽撞的记者小濑清被生活所迫踏入相扑部屋，面对严苛的训练与森严的规矩。他在一次次的较量与自我怀疑中逐渐理解这项运动的重量，也在世俗与荣誉间寻找出路。',
    subtitleNote: '字幕组整理了相扑等级、专业术语与比赛规则说明，帮助观众理解竞技细节。',
    subtitleVersions: [
      { id: 'tv-04-v1', language: '简体中文', team: '角斗字幕组', format: 'ASS', publishedAt: '2026-09-10', note: '含术语表' },
      { id: 'tv-04-v2', language: '繁体中文', team: '角斗字幕组', format: 'SRT', publishedAt: '2026-07-30' },
    ],
  },
  {
    id: 'tv-05',
    title: '非常律师禹英禑',
    originalTitle: '이상한 변호사 우영우',
    type: 'tv',
    region: 'kr',
    year: 2022,
    genre: '剧情 / 律政',
    subtitleStatus: 'completed',
    tags: ['律政', '治愈', '成长', '高口碑'],
    updatedAt: '2026-09-02',
    popularity: 9780,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20heartwarming%20Korean%20legal%20drama%20series%2C%20a%20young%20lawyer%20silhouette%20before%20tall%20sunlit%20law%20library%20shelves%20with%20a%20whale%20motif%20floating%2C%20soft%20sky%20blue%20and%20warm%20amber%20tones%2C%20bright%20hopeful%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-05&orientation=portrait',
    description: '患有自闭谱系的律师以独特的视角破解案件，用温柔与专业证明自己的价值。',
    synopsis: '拥有超高记忆力的新人律师禹英禑进入知名律所，她以与众不同看待世界的方式另辟蹊径。在一次次棘手案件中，她与同事互相成就，也慢慢学会与自己的不完美和解。',
    subtitleNote: '字幕组对法律条文与专有名词做了精准校对，并附鲸鱼相关旁白的背景注释。',
    subtitleVersions: [
      { id: 'tv-05-v1', language: '简体中文', team: '半岛字幕组', format: 'ASS', publishedAt: '2026-09-02' },
      { id: 'tv-05-v2', language: '繁体中文', team: '半岛字幕组', format: 'SRT', publishedAt: '2026-07-18' },
      { id: 'tv-05-v3', language: '中韩双语', team: '光影字幕', format: 'ASS', publishedAt: '2026-06-01' },
    ],
  },
  {
    id: 'tv-06',
    title: '黑暗荣耀',
    originalTitle: '더 글로리',
    type: 'tv',
    region: 'kr',
    year: 2022,
    genre: '剧情 / 复仇',
    subtitleStatus: 'completed',
    tags: ['复仇', '校园暴力', '悬疑', '爽剧'],
    updatedAt: '2026-08-26',
    popularity: 10120,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20dark%20Korean%20revenge%20drama%20series%2C%20a%20woman%20silhouette%20in%20a%20long%20coat%20under%20cold%20railway%20station%20light%20with%20chess%20piece%20motifs%2C%20deep%20charcoal%20and%20somber%20amber%20tones%2C%20tense%20ominous%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-06&orientation=portrait',
    description: '被校园暴力摧毁人生的女人，用一场精心布局的复仇夺回属于自己的荣耀。',
    synopsis: '文东恩高中时代遭遇残酷霸凌，被迫退学，人生被彻底改变。多年后她成为一所小学的班主任，并将复仇的目标对准施暴者的孩子。一场跨越十余年的棋局，在冷静与狠厉中缓缓落子。',
    subtitleNote: '字幕组为剧中的围棋术语与关键台词补充了双关注释，并整理了人物关系时间线。',
    subtitleVersions: [
      { id: 'tv-06-v1', language: '简体中文', team: '长夜字幕组', format: 'ASS', publishedAt: '2026-08-26', note: '含关系图' },
      { id: 'tv-06-v2', language: '繁体中文', team: '长夜字幕组', format: 'ASS', publishedAt: '2026-07-05' },
    ],
  },
  {
    id: 'tv-07',
    title: '财阀家的小儿子',
    originalTitle: '재벌집 막내아들',
    type: 'tv',
    region: 'kr',
    year: 2022,
    genre: '剧情 / 奇幻 / 商战',
    subtitleStatus: 'completed',
    tags: ['重生', '商战', '爽剧', '家族'],
    updatedAt: '2026-08-19',
    popularity: 9240,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20corporate%20revenge%20fantasy%20drama%20series%2C%20a%20young%20man%20silhouette%20before%20a%20towering%20glass%20skyscraper%20at%20golden%20hour%2C%20deep%20navy%20and%20rich%20amber%20tones%2C%20ambitious%20grand%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-07&orientation=portrait',
    description: '被财阀家族抛弃的秘书重生回到过去，成为家族小儿子，向命运讨回一切。',
    synopsis: '为财阀集团卖命多年的尹炫优意外身亡，却带着记忆重生为家族最小的孙子陈道俊。他利用对未来的预知，在家族权力斗争中步步为营，既要改写命运，也要守护心中最重要的东西。',
    subtitleNote: '字幕组对韩国财阀结构、股权与年代背景做了注释，帮助观众理解商战逻辑。',
    subtitleVersions: [
      { id: 'tv-07-v1', language: '简体中文', team: '财阀字幕组', format: 'ASS', publishedAt: '2026-08-19' },
      { id: 'tv-07-v2', language: '中韩双语', team: '财阀字幕组', format: 'ASS', publishedAt: '2026-06-22' },
    ],
  },
  {
    id: 'tv-08',
    title: '模范出租车 第2季',
    originalTitle: '모범택시 시즌2',
    type: 'tv',
    region: 'kr',
    year: 2023,
    genre: '动作 / 犯罪',
    subtitleStatus: 'in-progress',
    tags: ['复仇', '动作', '犯罪', '爽剧'],
    updatedAt: '2026-10-08',
    popularity: 8960,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20action%20crime%20drama%20series%2C%20a%20dark%20taxi%20cruising%20a%20neon%20wet%20city%20street%20at%20night%2C%20deep%20charcoal%20blue%20with%20hot%20amber%20highlights%2C%20gritty%20tense%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-08&orientation=portrait',
    description: '彩虹运输队重出江湖，用一辆出租车为无处申冤的人们讨回公道。',
    synopsis: '隐藏在出租车公司背后的复仇组织再度集结，金道奇与队友们接手新的委托。他们将线索追查到跨国犯罪网络，在惊险的行动与情感纠葛中，坚持“以恶制恶”的正义。',
    subtitleNote: '制作组正在校对动作场面中的环境台词与多语种对白，简繁版本即将陆续上线。',
    subtitleVersions: [
      { id: 'tv-08-v1', language: '简体中文', team: '彩虹字幕组', format: 'ASS', publishedAt: '2026-10-08', note: '校对中' },
    ],
  },
  {
    id: 'tv-09',
    title: '甜蜜家园',
    originalTitle: '스위트홈',
    type: 'tv',
    region: 'kr',
    year: 2020,
    genre: '惊悚 / 剧情 / 怪物',
    subtitleStatus: 'completed',
    tags: ['怪物', '末日', '生存', '惊悚'],
    updatedAt: '2026-08-08',
    popularity: 7640,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20apocalyptic%20monster%20horror%20drama%20series%2C%20a%20lone%20figure%20before%20a%20crumbling%20apartment%20block%20in%20fog%2C%20desaturated%20teal%20and%20cold%20amber%20tones%2C%20eerie%20suspenseful%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-09&orientation=portrait',
    description: '封闭公寓里的人们面对变异成怪物的邻居，在末日中艰难求生。',
    synopsis: '失去家人的少年车贤秀搬进破旧的绿之家公寓，却发现人们开始变异成映射内心欲望的怪物。他与幸存的邻居们被迫守住这栋楼，在恐惧与猜忌中挣扎求存。',
    subtitleNote: '字幕组为怪物设定与公寓生存规则提供了术语说明，并标注了每集悬念节点。',
    subtitleVersions: [
      { id: 'tv-09-v1', language: '简体中文', team: '幽闭字幕组', format: 'ASS', publishedAt: '2026-08-08' },
      { id: 'tv-09-v2', language: '繁体中文', team: '幽闭字幕组', format: 'SRT', publishedAt: '2026-06-15' },
    ],
  },
  {
    id: 'tv-10',
    title: '半泽直树 第2季',
    originalTitle: '半沢直樹 シーズン2',
    type: 'tv',
    region: 'jp',
    year: 2020,
    genre: '剧情 / 职场 / 商战',
    subtitleStatus: 'completed',
    tags: ['职场', '商战', '励志', '经典'],
    updatedAt: '2026-07-28',
    popularity: 7320,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Japanese%20corporate%20banking%20drama%20series%2C%20a%20determined%20businessman%20silhouette%20in%20front%20of%20a%20strict%20glass%20office%20grid%2C%20deep%20indigo%20and%20warm%20amber%20tones%2C%20intense%20dramatic%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-10&orientation=portrait',
    description: '银行职员半泽直树再度出击，在权力与算计较量中坚守原则、绝地反击。',
    synopsis: '调任证券公司的半泽直树卷入一场巨额收购风波，他必须在多方角力中找出幕后黑手。面对上司的施压与对手的算计，他依旧秉持“以牙还牙，加倍奉还”的信念迎难而上。',
    subtitleNote: '字幕组整理了金融术语与银行人事制度说明，并保留了经典的台词金句样式。',
    subtitleVersions: [
      { id: 'tv-10-v1', language: '简体中文', team: '倍返字幕组', format: 'ASS', publishedAt: '2026-07-28', note: '含金融术语' },
      { id: 'tv-10-v2', language: '中日双语', team: '倍返字幕组', format: 'ASS', publishedAt: '2026-06-10' },
    ],
  },
  {
    id: 'tv-11',
    title: 'Doctor X 外科医大门未知子',
    originalTitle: 'ドクターX ～外科医・大門未知子～',
    type: 'tv',
    region: 'jp',
    year: 2021,
    genre: '医疗 / 剧情',
    subtitleStatus: 'completed',
    tags: ['医疗', '职场', '经典', '爽剧'],
    updatedAt: '2026-07-16',
    popularity: 6880,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Japanese%20medical%20drama%20series%2C%20a%20confident%20surgeon%20silhouette%20in%20a%20bright%20operating%20theatre%20with%20surgical%20lights%2C%20clean%20white%20and%20cool%20teal%20with%20warm%20amber%20accents%2C%20crisp%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-11&orientation=portrait',
    description: '自由外科医生大门未知子拒绝一切不合理，用手术刀挑战白色巨塔的权威。',
    synopsis: '不属于任何医院体制的门未知子，以自由外科医生的身份辗转于各家医院。她拒绝派系与应酬，用一次次高难度手术证明实力，也一次次戳破医疗体系中的裙带与虚伪。',
    subtitleNote: '字幕组对医学术语与手术流程做了专业校对，并附赠经典台词“我绝不会失败”彩蛋集锦。',
    subtitleVersions: [
      { id: 'tv-11-v1', language: '简体中文', team: '手术刀字幕组', format: 'ASS', publishedAt: '2026-07-16' },
      { id: 'tv-11-v2', language: '繁体中文', team: '手术刀字幕组', format: 'SRT', publishedAt: '2026-05-30' },
    ],
  },
  {
    id: 'tv-12',
    title: '我的出走日记',
    originalTitle: '나의 해방일지',
    type: 'tv',
    region: 'kr',
    year: 2022,
    genre: '剧情 / 治愈',
    subtitleStatus: 'in-progress',
    tags: ['治愈', '现实', '文青', '生活流'],
    updatedAt: '2026-10-10',
    popularity: 7060,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20quiet%20Korean%20healing%20slice%20of%20life%20drama%20series%2C%20three%20siblings%20silhouettes%20on%20a%20suburban%20hill%20at%20golden%20hour%2C%20soft%20sage%20green%20and%20warm%20amber%20tones%2C%20calm%20bittersweet%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-tv-12&orientation=portrait',
    description: '三兄妹在平凡生活中积攒着苦闷，直到一个神秘外乡人的出现带来一丝解放。',
    synopsis: '住在京畿道郊外的廉家三兄妹各自承受着生活的疲惫与失望。当来路不明的具氏开始在村里打工，小妹廉美贞提出“崇拜我吧”，一段关于自我救赎与互相照亮的故事悄然展开。',
    subtitleNote: '字幕组正在精细打磨旁白与内心独白的时间轴，预计同步推出简繁双语版本。',
    subtitleVersions: [
      { id: 'tv-12-v1', language: '简体中文', team: '解放字幕组', format: 'ASS', publishedAt: '2026-10-10', note: '校对中' },
    ],
  },
];